/**
 * The keyboard shortcuts, listed. Opened with "?" or from the account menu.
 */
import { Modal } from '../components/Modal.jsx';
import { MOD_KEY } from './Topbar.jsx';

const SHORTCUTS = [
  { keys: [MOD_KEY, 'K'], label: 'Open the command center — search organizations, pages and actions' },
  { keys: ['/'], label: 'Open the command center' },
  { keys: ['['], label: 'Collapse or expand the navigation' },
  { keys: ['?'], label: 'Show these shortcuts' },
  { keys: ['↑', '↓'], label: 'Move through results in the command center' },
  { keys: ['Enter'], label: 'Open the highlighted result' },
  { keys: ['Esc'], label: 'Close a menu, panel or dialog' },
];

export function ShortcutsDialog({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose} title="Keyboard shortcuts" description="Move around the console without the mouse.">
      <dl className="shortcuts">
        {SHORTCUTS.map((shortcut) => (
          <div key={shortcut.label} className="shortcuts-row">
            <dt className="shortcuts-keys">
              {shortcut.keys.map((key) => (
                <kbd key={key}>{key}</kbd>
              ))}
            </dt>
            <dd>{shortcut.label}</dd>
          </div>
        ))}
      </dl>
    </Modal>
  );
}
